import React from "react";
import DatePicker from "react-datepicker";

const DatePickers = ({startDate, setStartDate, endDate, setEndDate}) => {
  return (
    <>
      <div className="mt-2 col-xs-12 col-lg-4 pl-0 ml-0 datepicker-input-wrapper d-inline-block">
        <DatePicker
          className="form-control pl-2 datepicker-input"
          placeholderText="Taken after..."
          selected={startDate}
          onChange={setStartDate}
        />
      </div>
      <div className="ml-0 datepicker-input-wrapper mt-2 col-xs-12 col-lg-4 pl-0 d-inline-block">
        <DatePicker
          className="form-control pl-2 datepicker-input"
          placeholderText="Taken before ..."
          selected={endDate}
          onChange={setEndDate}
        />
      </div>
    </>
  );
};

export default DatePickers;
